<nz-spin [nzSpinning]="(createOrderTemplatePending$ | async) || (fetchOrderTemplatesMinPending$ | async) || (addOrderTemplateItemPending$ | async)" [nzIndicator]="loadingIndicatorTemplate">
    <div class="add-to-order-templates-container" [formGroup]="form">
        <div nz-row>
            <div nz-col nzSpan="8">
                <div class="cart-form-generic-details">
                    <leap-product-cart-form-generic-details *ngIf="newPricingDetails"
                                                            [profile]="profile"
                                                            [product]="product"
                                                            [selectedVariant]="selectedVariant"
                                                            [expiringContract]="expiringContract"
                                                            [details]="details"

                                                            [currencySign]="currencySign"
                                                            [basePrice]="newPricingDetails?.pricing?.basePrice"
                                                            [surchargeTotalAmount]="newPricingDetails?.pricing?.surchargeTotalAmount"

                    ></leap-product-cart-form-generic-details>
                    <div class="cart-form-quantity">
                        <div *leapHasGroup="['buyer']">
                            <div class="quantity" >Quantity: <input name="quantity" nz-input type="number" min="1" [formControlName]="'quantity'"></div>
                            <p class="description" *ngIf="product.type === 'Exam'">Tip: You need one exam per participant</p>
                        </div>
                    </div>
                </div>

            </div>
            <div nz-col nzSpan="16">
                <h3>Choose Order Template</h3>
                <div style="position: relative; margin-bottom: 20px;">
                    <div class="order-template-list" *ngIf="!(fetchOrderTemplatesMinPending$ | async) && (orderTemplatesList$ | async)?.length">
                        <div nz-row class="order-template-list-item" *ngFor="let template of orderTemplatesList$ | async">
                            <ng-container *ngIf="includeSelectedVariant(template)">
                                <div nz-col nzSpan="18">
                                    <div class="order-template-name"><span (click)="goToTemplateDetails(template.id)">{{template.name}}</span></div>
                                    <div class="order-template-caption">
                                        {{variantQuantityInTemplate(template)}} copy(ies) of this product. To change quantity, <a href="/order-templates/details/{{template.id}}">Edit Order Template</a>
                                    </div>
                                </div>
                                <div nz-col nzSpan="6" style="text-align: right">
                                    <span  *ngIf="includeSelectedVariant(template)" class="already-added">
                                        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="visible" preserveAspectRatio="none" viewBox="0 0 450 514" xml:space="preserve" y="0px" x="0px" id="Layer_1_1573220607061" width="19" height="22"><g transform="translate(1, 1)"><style type="text/css">.st0_1573220607061{fill:#394042;}</style><path d="M413.5,92l-280,280l-99-99c-4.7-4.7-12.3-4.7-17,0L6.2,284.3c-4.7,4.7-4.7,12.3,0,17L125,420  c4.7,4.7,12.3,4.7,17,0l299.8-299.8c4.7-4.7,4.7-12.3,0-17L430.5,92C425.8,87.3,418.2,87.3,413.5,92L413.5,92z" class="st0_1573220607061" vector-effect="non-scaling-stroke" style="fill: rgb(56, 182, 160);"/></g></svg>
                                    </span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!includeSelectedVariant(template)">
                                <div nz-col nzSpan="18">
                                    <div class="order-template-name"><span (click)="goToTemplateDetails(template.id)">{{template.name}}</span></div>
                                </div>
                                <div nz-col nzSpan="6" style="text-align: right">
                                    <div (click)="addProductToOrderTemplate(template.name)" style="padding: 3px 25px;" nz-button nzType="primary" nzSize="small">Add</div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <ng-container *ngIf="!(fetchOrderTemplatesMinPending$ | async) && !(orderTemplatesList$ | async)?.length">
                        <div nz-row style="height: 177px">
                            <div nz-col [nzLg]="24" [nzMd]="24">
                                <nz-empty [nzNotFoundContent]="nzNotFoundContent" style="margin: 20px;"></nz-empty>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div class="create-new-template">
                    <div nz-row>
                        <div nz-col nzSpan="18">
                            <input [ngClass]="(createOrderTemplateError$ | async) ? 'has-error-input' : null" [formControlName]="'newTemplateName'" nz-input placeholder="Start Typing New Order Template Name" (focus)="clearState()" />
                            <nz-form-explain *ngIf="createOrderTemplateError$ | async">
                                <span i18n="Order template already exists|@@ordertemplatecreate.name.required">Order template already exists!</span>
                            </nz-form-explain>
                            <nz-form-explain *ngIf="form.controls.newTemplateName.errors && form.controls.newTemplateName.errors.maxlength">
                                <span i18n="Name length error in add order template form|@@orderTemplate.addForm.name.length">Name is too long, max 120 characters!</span>
                            </nz-form-explain>
                            <div class="create-new-template-caption">
                                The new Order Template will be added to the list above. You can start adding items to it right away
                            </div>
                        </div>
                        <div nz-col nzSpan="6" style="text-align: right">
                            <button style="padding: 6px 25px;" nz-button nzType="default" [disabled]="form.invalid" (click)="createTemplate()">Create New</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div nz-row class="cancel-button-container">
            <button nz-button [nzSize]="'large'" nzType="default" (click)="closeModal()">Close</button>
        </div>

    </div>
</nz-spin>

<ng-template #loadingIndicatorTemplate>
    <i nz-icon nzType="loading" style="font-size: 24px;position: absolute; top: 50%"></i>
</ng-template>

<ng-template #nzNotFoundContent>
    <span>No order templates found.</span>
</ng-template>
